module.exports = __webpack_public_path__ + "img/img5.68eb1574.png";